module.exports = __webpack_public_path__ + "img/logo_sch.3e22113d.png";